<template>
  <Header></Header>
  <div class="body-app">
    <transition name='custom-classes' enter-active-class="animate__animated animate__fadeIn animate__slow">
      <router-view />
    </transition>
  </div>
  <Footer></Footer>
</template>


<script>
  import Header from "@/components/header.vue";
  import Footer from "@/components/footer.vue";
  import utils from "@/utils/utils.js";

  export default {
    name: 'App',
    components: {
      Header,
      Footer,
    },

  }
</script>

<style lang="scss">
  @import "@/styles/general.scss";
  @import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,700,800|Yeseva+One');
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
</style>